import React, { useEffect } from 'react';
import './style.scss';
import { useHistory } from 'react-router-dom';
import { Notification } from 'components';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { doLogin, doLogin3G } from 'store/action/userAction';
import icon_5g from 'assets/imgs/icon-5g.png';
import map from 'assets/imgs/maps.png';

const CryptoJS = require("crypto-js");
const KEY_SECRET = 'VNPTMEDIA@57';

function removeParam(key, sourceURL) {
  let rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (let i = params_arr.length - 1; i >= 0; i--) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

function decode(value) {
  if (!value) {
    return {};
  }
  const bytes = CryptoJS.AES.decrypt(value, KEY_SECRET);
  const text = bytes.toString(CryptoJS.enc.Utf8);
  const arr = text.split(',');
  return {
    msisdn: arr[0],
    session: arr[1]
  }
}

const Login3G = () => {
  const history = useHistory();
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    const code = window.location.href.split('code=')[1];
    const { msisdn, session } = decode(code);
    const slug = history.location.pathname.replace('/dang-nhap', '');

    let params = history.location.search;
    params = removeParam('code', params);

    if (!msisdn || !session) {
      Notification.error("Đăng nhập 3G/4G không thành công!");
    } else {
      localStorage.setItem('mobile', msisdn);
      localStorage.setItem('session', session);
      localStorage.setItem('authorized', true);
      dispatch(doLogin());
      Notification.success(intl.formatMessage({ id: 'IDS_LOGIN_OTP_SUCCESS' }));
    }
    dispatch(doLogin3G());
    history.push(`${slug}${params}`);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="login3g">
      <img alt="map" className="login3g__map" src={map} />
      <div className="login3g__icon-top">
        <img className="login3g__5g" alt="5g" src={icon_5g} />
      </div>
      <div className="login3g__icon-bottom">
        <img className="login3g__5g" alt="5g" src={icon_5g} />
      </div>
      <div className="boxTopCircle">
        <div className="boxPoint">
          <div className="circle one" />
          <div className="circle two" />
          <div className="circle three" />
          <div className="circle four" />
          <div className="circle five" />
        </div>
      </div>
      <div className="boxBottomCircle">
        <div className="boxPoint">
          <div className="circle one" />
          <div className="circle two" />
          <div className="circle three" />
          <div className="circle four" />
          <div className="circle five" />
        </div>
      </div>
      {/* <ProgressTurn /> */}
    </div>
  );
}

export default React.memo(Login3G);
